import FormField, {
  FormFieldSelectProps,
} from 'components/form-field/form-field';
import { useSelectZohoOrganizationFieldQuery } from 'generated/graphql';
import React, { Fragment, FunctionComponent, useMemo } from 'react';

import { DropdownItemProps } from 'semantic-ui-react';

type SelectZohoOrganizationFieldProps = Omit<
  FormFieldSelectProps,
  'options' | 'type' | 'loading'
>;

const SelectZohoOrganizationField: FunctionComponent<
  SelectZohoOrganizationFieldProps
> = ({ multiple, ...rest }) => {
  const { data, loading, error } = useSelectZohoOrganizationFieldQuery({
    fetchPolicy: 'no-cache',
  });

  const options: DropdownItemProps[] = useMemo(() => {
    if (data?.zohoOrganization) {
      return data.zohoOrganization.map((zohoOrganization) => ({
        key: zohoOrganization.id,
        value: zohoOrganization.id,
        text: `${zohoOrganization.name} - ${zohoOrganization.organizationId}`,
      }));
    }
    return [];
  }, [data?.zohoOrganization]);

  const placeholder = useMemo(() => {
    if (loading) {
      return 'Chargement des organisations zoho...';
    }
    if (multiple) {
      return 'Selectionnez des organisations...';
    }
    return 'Selectionnez une organisation...';
  }, [loading, multiple]);

  if (error) return <Fragment>Error! {error.message}</Fragment>;

  return (
    <FormField
      type="select"
      loading={loading}
      disabled={loading}
      options={options}
      multiple={multiple}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default SelectZohoOrganizationField;
